import React from "react";
import { useFetch } from "@/hooks/useApi";
import { PageHeader, Loader, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { ukDateTime } from "@/lib/format";
import * as Icons from "lucide-react";

const ICONS = {
  stop_approval: "ClipboardCheck", rate_change: "Percent", ticket_deduction: "Receipt",
  fuel_log: "Fuel", expense_change: "Wrench", van_assignment: "Truck",
  create: "Plus", delete: "Trash2",
};
const COLORS = {
  stop_approval: "text-emerald-400", rate_change: "text-blue-400", ticket_deduction: "text-rose-400",
  fuel_log: "text-amber-400", expense_change: "text-amber-400", van_assignment: "text-indigo-400",
  create: "text-emerald-400", delete: "text-rose-400",
};

export default function AuditLog() {
  const { data, loading } = useFetch("/audit");
  if (loading || !data) return <Loader />;
  return (
    <div className="fp-fade-in">
      <PageHeader title="Audit Log" subtitle="Immutable record of key changes across the fleet" testId="audit-page" />
      <Card className="p-2">
        {data.length === 0 ? <EmptyState icon="ScrollText" title="No activity yet" /> : (
          <div className="divide-y divide-border">
            {data.map((a) => {
              const Icon = Icons[ICONS[a.action]] || Icons.Circle;
              return (
                <div key={a.id} className="flex items-start gap-3 p-3" data-testid={`audit-row-${a.id}`}>
                  <div className={`h-9 w-9 rounded-lg bg-muted grid place-items-center shrink-0 ${COLORS[a.action] || "text-muted-foreground"}`}>
                    <Icon className="h-4 w-4" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-foreground">{a.detail}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      <span className="capitalize">{a.action.replace(/_/g, " ")}</span> · {a.user_name || a.user_email} · {ukDateTime(a.timestamp)}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Card>
    </div>
  );
}
